import { t } from "@lingui/macro";
import React from "react";
import { Pressable } from "react-native";

import { Box, VStack } from "@whoosh/design-system/src/components/primitive";

import { PublicAvailableSlotBody } from "./components/PublicAvailableSlotBody";
import { PublicRequestBody } from "./components/PublicRequestBody";

type BorderRadiusOption = "0" | "0.5" | "1" | "2" | "4" | "6" | "8" | "full";

type PublicTimeSlotCardProps = {
  time?: string;
  availableSpots?: number;
  isRequestAvailable?: boolean;
  onPress?: () => void;
  borderRadius?: {
    top?: BorderRadiusOption;
    bottom?: BorderRadiusOption;
  };
  location?: string;
  prices?: number[];
  rateName?: string;
  layouts?: string[];
  restrictionList?: React.JSX.Element;
};

export const PublicTimeSlotCard = ({
  time,
  availableSpots,
  isRequestAvailable,
  onPress,
  borderRadius,
  location,
  prices,
  rateName,
  layouts,
  restrictionList,
}: PublicTimeSlotCardProps) => {
  const borderRadiusSizes = {
    "0": 0,
    "0.5": 2,
    "1": 4,
    "2": 8,
    "4": 16,
    "6": 24,
    "8": 32,
    full: 1000,
  };

  const borderTopRadius = borderRadiusSizes[borderRadius?.top ?? "0"];
  const borderBottomRadius = borderRadiusSizes[borderRadius?.bottom ?? "0"];

  const showCard =
    ((availableSpots ?? 0) > 0 &&
      layouts &&
      layouts.length > 0 &&
      prices &&
      prices.length > 0) ||
    isRequestAvailable;

  const disabled = onPress === undefined;
  return showCard ? (
    <Pressable
      style={({ pressed }) => ({
        borderBottomLeftRadius: borderBottomRadius,
        borderBottomRightRadius: borderBottomRadius,
        borderTopLeftRadius: borderTopRadius,
        borderTopRightRadius: borderTopRadius,
        padding: 4,
        borderWidth: 0,
        backgroundColor:
          (pressed && onPress) || disabled ? "surface-primary" : "white",
        shadowColor: "#000000",
        shadowOffset: { width: 0, height: 2 },
        shadowRadius: 6,
        shadowOpacity: 0.04,
        elevation: 2, // for Android shadow
      })}
      onPress={onPress}
      disabled={disabled}
      aria-label={t`time-slot-card`}
      testID={`public-time-slot-card-${location}-${time}`}
    >
      <VStack>
        {restrictionList ? restrictionList : null}
        <Box p={3}>
          {isRequestAvailable ? (
            <PublicRequestBody time={time} location={location} />
          ) : (availableSpots ?? 0) > 0 ? (
            <PublicAvailableSlotBody
              location={location}
              time={time}
              prices={prices}
              availableSpots={availableSpots}
              layouts={layouts}
              rateName={rateName}
            />
          ) : null}
        </Box>
      </VStack>
    </Pressable>
  ) : null;
};
